module.exports = __webpack_public_path__ + "img/96.6f753eec.jpg";